//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Handshake, UsersRound, HandCoins } from 'lucide-react';
import { useInView } from 'react-intersection-observer'; // For scroll detection

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

const StatContainer = styled.div`
  text-align: center;
  margin: 0 20px;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 20px 10px;
  }
`;

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ffebe0;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 20px;
`;

const StatNumber = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
`;

const StatLabel = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 10px;
`;

const StatDescription = styled.p`
  font-size: 0.8rem;
  color: #888;
`;

const StatsSection = () => {
  const [variationsCount, setVariationsCount] = useState(0);
  const [lessonsCount, setLessonsCount] = useState(0);
  const [workshopsCount, setWorkshopsCount] = useState(0);

  const [ref, inView] = useInView({
    triggerOnce: true, // Trigger only once when in view
    threshold: 0.1, // Trigger when 10% of the section is visible
  });

  useEffect(() => {
    if (inView) {
      const increment = (target, setter, duration) => {
        let start = 0;
        const startTime = performance.now();

        const animate = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);
          setter(Math.floor(progress * target));

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      };

      increment(800, setVariationsCount, 2000); // 1.5 seconds animation
      increment(5000, setLessonsCount, 2000);
      increment(149, setWorkshopsCount, 2000);
    }
  }, [inView]);

  return (
    <SectionContainer ref={ref} className="manrope-regular">
      <StatContainer>
        <IconWrapper>
          <Handshake color="#ea5d0f" size={32} />
        </IconWrapper>
        <StatNumber>{variationsCount.toLocaleString()}+</StatNumber>
        <StatLabel>Enterprise</StatLabel>
        <StatDescription>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rerum, ut.
          adipisicing elit. Rerum, ut.
        </StatDescription>
      </StatContainer>

      <StatContainer>
        <IconWrapper>
          <UsersRound color="#ea5d0f" size={32} />
        </IconWrapper>
        <StatNumber>{lessonsCount.toLocaleString()}+</StatNumber>
        <StatLabel>Users</StatLabel>
        <StatDescription>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rerum, ut.
        </StatDescription>
      </StatContainer>

      <StatContainer>
        <IconWrapper>
          <HandCoins color="#ea5d0f" size={32} />
        </IconWrapper>
        <StatNumber>{workshopsCount.toLocaleString()}+</StatNumber>
        <StatLabel>Gigs</StatLabel>
        <StatDescription>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rerum, ut.
        </StatDescription>
      </StatContainer>
    </SectionContainer>
  );
};

export default StatsSection;
